import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

// Closes a dialog modal when connected (used by Turbo Stream responses)
export default class extends Controller {
  connect() {
    // Close the dialog element and remove backdrop
    if (this.element.tagName === 'DIALOG') {
      // Use setTimeout to ensure the dialog is fully rendered before closing
      setTimeout(() => {
        if (this.element && this.element.close) {
          this.element.close()
          // Remove the element after closing to ensure backdrop is gone
          setTimeout(() => {
            if (this.element && this.element.parentNode) {
              this.element.parentNode.removeChild(this.element)
            }
          }, 100)
        }
      }, 50)
    }
  }
}
